import { ColumnComponent, RowComponent } from 'tabulator-tables';

export function formatCellsToClipboard(rows: RowComponent[], columns: ColumnComponent[]): string {
	return rows.map((row) => columns.map((col) => row.getCell(col).getValue()).join('\\t')).join('\\n');
}

export function formatClipboardToCells(text: string): string[][] {
	return text.split('\\n').map((row) => row.split('\\t'));
}
